export const getSuggestions = state => state.suggestions;
export const getVisibility = state => state.isVisible;
export const getAddressValidity = state => state.isValid;
export const getSelectedAddress = state => state.selectedAddress;
export const getSelectedAddressFormatted = (state) => {
  const selectedAddress = state.selectedAddress;
  let addressFormatted;

  if (selectedAddress.StreetName) {
    addressFormatted = `${selectedAddress.StreetName}, ${selectedAddress.PostalCode} - ${selectedAddress.CityDescription}`;
  }

  return addressFormatted;
};
export const getNotCoveredAddress = state => state.notCovered;
export const getValidity = state => state.isValid;
export const getTimesInCoverage = state => state.timesInCoverage;
export const getCoverageType = state => state.coverageType;

export default {
  getSuggestions,
  getValidity,
  getVisibility,
  getAddressValidity,
  getSelectedAddress,
  getSelectedAddressFormatted,
  getNotCoveredAddress,
  getTimesInCoverage,
  getCoverageType
};



// WEBPACK FOOTER //
// ./src/store/modules/addresses/getters.js